function AutoSuggestTracker(analytics) {

    this.analytics = analytics;
    this.$input = $('#q');
}

AutoSuggestTracker.prototype = {
    init() {

        if (!this.$input.length) {
            return this;
        }

        this.initSearchValueTracking()
            .initSearchSelectionTracking();
    },

    /**
 * @return {AutoSuggestTracker}
 */
    initSearchValueTracking() {
        this.$input.on('change', $.proxy(this.trackSearchValue, this));
        return this;
    },

    /**
     * @return {AutoSuggestTracker}
     */
    initSearchSelectionTracking() {
        this.$input.parent().on('click', 'a', $.proxy(this.trackSearchSelection, this));
        return this;
    },

    /**
     * @return {AutoSuggestTracker}
     */
    trackSearchValue() {
        this.analytics.track('Search', 'input', this.$input.val(), 1);
        return this;
    },

    /**
     * @param  {Object} event
     * @return {AutoSuggestTracker}
     */
    trackSearchSelection(event) {
        event.preventDefault();
        var a = event.currentTarget;

        this.analytics.trackWithCallback(
            {
                eventName: 'Search',
                eventBody: {
                    event_category: 'Selection',
                    event_label: a.text
                }
            },
            this.redirect.bind(this, a.href)
        );

        return this;
    },

    /**
     * @param  {String} url
     */
    redirect(url) {
        window.location = url;
    }
};

export default AutoSuggestTracker;